import * as React from 'react';
import * as Yup from 'yup';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Button } from 'Src/components/Button/Button';

interface Props {
  onCancel: () => void;
  onSubmit: (data) => void;
}

const NotificationSchema = Yup.object().shape({
  title: Yup.string().required('Required'),
  body: Yup.string().required('Required'),
});

export function CustomSendTestNotificationForm(props: Props) {
  const { onSubmit, onCancel } = props;
  const notificationForm = {
    title: '',
    body: '',
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <Formik initialValues={notificationForm} validationSchema={NotificationSchema} onSubmit={onSubmit}>
            {({ touched, errors, handleSubmit }) => (
              <Form>
                <div className="form-group form-check">
                  <div className="form-group">
                    <label>Title</label>
                    <Field name="title" className="form-control mb-3" />
                    <ErrorMessage component="div" className="alert alert-danger" name="title" />
                  </div>

                  <div className="form-group">
                    <label>Message</label>
                    <Field name="body" className="form-control mb-3" />
                    <ErrorMessage component="div" className="alert alert-danger" name="body" />
                  </div>

                  <Button
                    onClick={onCancel}
                    text={'Cancel'}
                    customClass={'btn btn-primary mt-3 mb-3 mr-3 btn-secondary'}
                  />
                  <Button
                    onClick={handleSubmit}
                    text={'Send'}
                    customClass={'mt-3 mb-3 btn btn-primary'}
                    type={'submit'}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
